export interface User {
  addressLine1?: any;
  addressLine2?: any;
  city: string;
  state: string;
  zip?: any;
  displayName: string;
  email: string;
  firstName: string;
  lastName: string;
  tenantId: string;
  userId: string;
  roles: string[];
  phoneNumber?: any;
  dob?: any;
  thumbnail?: any;
  optIn?: any;
  optInSetting?: any;
}

export interface navList {
  // Array of object Interface
  [index: number]: {
    name: string;
    icon_class: string;
    url: string;
    visible: boolean;
  };
}

export interface scoredData {
  parentSlug: string;
  scored: [
    {
      key: string;
      points: number;
    }
  ];
  scoredPoints: number;
}

export enum STATUS {
  accepted = "ACCEPTED",
  notAccepted = "NOT ACCEPTED",
  completed = "COMPLETED",
  inProgress = "INPROGRESS",
  needMoreInfo = "NEED MORE INFO",
  received = "RECEIVED",
  processing = "PROCESSING",
}

export interface fileValidation {
  name: string;
  veeValidate: string;
}

export interface attachmentData {
  files: any[];
  payloadName: string;
}

export interface attachment {
  files: any[];
  payloadName: string;
  title: string;
  authorizationDoc?: any;
}

export interface OfflineFormData {
  id: string;
  attributes: formAttrubutes;
}

export interface formAttrubutes {
  parent_slug: string;
  form_fields: {
    formInupts: [formInputs[] | []];
  };
  form_name: string;
}
export interface formInputs {
  name: string;
  class: string;
  mainClass: string;
  field: string;
  label: string;
  s3Name: string;
  propBind: {
    type: string;
    eventName: string;
  };
  validate: {
    name: string;
    required: boolean;
    veeValidate: string;
    maxLength: number;
  };
  fileValid: {
    name: string;
    veeValidate: string;
  };
}

export interface filters {
  limit: number;
  offset: number;
  sort: string;
  sortBy: string;
  from: Date;
  to: Date;
  status: string;
}

export interface reviewerDataTable {
  [x: string]: any;
  certificateNumber?: string;
  certifiedAt?: string;
  submittedMode: string;
  createdAt: string;
  id: string;
  code: string;
  firstName: string;
  lastName: string;
  email: string;
  data: any;
  progressStatus: string;
  fillStatus: string;
  action?: boolean;
  rubric: string;
  comment: string;
  userTask: [
    {
      createdAt: string;
      status: string;
      userId: string;
    }
  ];
}

export interface certificationDetails {
  file: File[];
  certificateNumber?: string;
  applicationId: string;
}

export interface docLibraryData {
  attributes: {
    keyName: string;
    documentName: string;
    document: {
      data: {
        attributes: {
          hash: string;
          mime: string;
          name: string;
          provider: string;
          url: string;
        };
      };
    };
  };
}

export interface editChangesData {
  editDataTime: string;
  editorDetails: {
    email: string;
    name: string;
    userId: string;
  };
  fieldName: string;
  label: string;
  mainLabel: string;
  newValue: any;
  oldValue: any;
  parentName: string;
  isRemoved: boolean;
  isNewlyAdded: boolean;
  index: number;
}
export interface dateRange {
  startDate: any;
  endDate: any;
}
